import { createFileRoute } from "@tanstack/react-router";
import {
 COMMERCIAL_SOCIAL_VALUE_PATH,
 COMMERCIAL_SOCIAL_VALUE_TITLE,
 LpCommercialSocialValue,
} from "@/components/landing/lp-commercial-social-value";
import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const DESCRIPTION =
 "Social value reporting for framework programmes: local jobs, apprenticeships, local supply chain and community benefit, agreed up front and evidenced on completion.";

export const Route = createFileRoute("/commercial-social-value")({
 head: () => ({
 ...pageSeo({
 path: COMMERCIAL_SOCIAL_VALUE_PATH,
 title: `${COMMERCIAL_SOCIAL_VALUE_TITLE} | Framework Reporting | CRS Energy`,
 description: DESCRIPTION,
 ogType: "article",
 }),
 scripts: [
 serviceJsonLdScript({
 name: COMMERCIAL_SOCIAL_VALUE_TITLE,
 description: DESCRIPTION,
 serviceType: "Social Value Reporting",
 url: `${SITE.url}${COMMERCIAL_SOCIAL_VALUE_PATH}`,
 }),
 breadcrumbJsonLdScript(
 commercialBreadcrumbTrail(COMMERCIAL_SOCIAL_VALUE_TITLE, COMMERCIAL_SOCIAL_VALUE_PATH)
 ),
 ],
 }),
 component: () => <LpCommercialSocialValue />,
});
